import { defineComponent as _defineComponent } from 'vue'
import { computed, inject } from 'vue';
import CompetitionEventsItemOld from '@/features/sports/components/overview/CompetitionEventsItemOld.vue';
import { CollectionType } from '@/enums/collection-type';
import { formatDateTime, isToday, shiftDateWithTimezone } from '@/helpers/date-helper';
import {
	Platform,
	SportCompetitionV2,
	SportEventAggregation,
	SportEventBucketsEdgeV2,
	SportType,
} from '@/@types/graphql-types';
import {
	GetMultiStepSportOverviewDocument,
	GetMultiStepSportOverviewQueryVariables,
} from '@/features/sports/graphql/queries/GetMultiStepSportOverview.query';
import type { SnowplowContext } from '@/helpers/tracking/providers';
import type { FilterCollection } from '@/stores/useFilterStoreTypes';
import { useQuery } from '@/helpers/composables/useApollo';
import { useFilterStore } from '@/stores/pinia/useFilterStore';
import { useRoute } from 'vue-router/composables';
import { useI18n } from '@/helpers/composables/useI18n';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyCalendarOld',
  props: {
    sportType: null,
    displayDate: null,
    daysLookAhead: { default: 7 },
    additionalContexts: { default: () => [] as SnowplowContext[] }
  },
  setup(__props: any) {

const props = __props as { sportType: SportType[], displayDate: Date, daysLookAhead: number, additionalContexts: SnowplowContext[] };



const { filters } = useFilterStore();

const { localeObject, country, language } = storeToRefs(useLanguageStore());

const route = useRoute();

const { tc, t } = useI18n();

const getEmptyCompetitionHeading = inject<(competition: SportEventBucketsEdgeV2) => string>(
	'getEmptyCompetitionHeading',
	() => ''
);

const filtersSport = computed<FilterCollection>(() => filters(CollectionType.SPORTS));

const queryVariables = computed<GetMultiStepSportOverviewQueryVariables>(() => {
	return {
		language: language.value,
		country: country.value,
		platform: Platform.Web,
		groupBy: SportEventAggregation.Competition,
		bucketSize: 3,
		first: 2,
		filter: {
			startAt: {
				from: shiftDateWithTimezone(localeObject.value.timezone, 0, props.displayDate).toISOString(),
				to: shiftDateWithTimezone(
					localeObject.value.timezone,
					props.daysLookAhead,
					props.displayDate
				).toISOString(),
			},
			packages: filtersSport.value.providers ?? [],
			sports: [props.sportType].flat(),
		},
		timezoneOffset: 0,
	};
});

const { result: fallbackData } = useQuery<SportCompetitionV2, GetMultiStepSportOverviewQueryVariables>(
	GetMultiStepSportOverviewDocument,
	queryVariables,
	() => ({
		enabled: route.name === 'app.sports.subdomain.overview' || route.name === 'app.sports.overview',
	})
);

const eventBuckets = computed(() => fallbackData.value?.sportEventBucketsV2);

const competitions = computed(() =>
	(eventBuckets.value?.edges ?? []).filter(edges => (edges.node.edges ?? []).length > 0)
);
const messageText = computed(() => {
	if (isToday(props.displayDate)) {
		return tc('SPORTS_WEBAPP_NO_EVENTS_TODAY');
	}

	const date = formatDateTime(props.displayDate, language.value, country.value);
	return t('SPORTS_WEBAPP_NO_EVENTS_DATE', { date });
});

return { __sfc: true,props, filters, localeObject, country, language, route, tc, t, getEmptyCompetitionHeading, filtersSport, queryVariables, fallbackData, eventBuckets, competitions, messageText, CompetitionEventsItemOld }
}

})